// Module
var code = "<p>If you did not request to pay your interest in advance, we mail Interest Notices, at least once a year while you are in school, grace, deferment, or forbearance, giving you plenty of time to make your payment.</p> ";
// Exports
export default code;